// @flow
import React, { Fragment, Component } from 'react';
import type { BlocContent } from 'types/NewsletterBloc';
import type { CardType, NewsNunType } from 'types/PageList';
import type { ArticleType } from 'types/Article';
import type { Status } from 'types/Status';

import CardThumbnail from 'components/fragments/card/CardThumbnail';
import CardBackground from 'containers/fragments/card/CardBackgroundContainer';
import Breadcrumb from 'components/fragments/Breadcrumb';
import FooterArticle from 'components/newsletter/FooterArticle';
import FooterNews from 'components/page/FooterNews';

type Props = {
  title: string,
  description: Array<BlocContent>,
  label: {
    id: number,
    name: string,
    slug: string
  },
  featured_media: {
    src: string,
    legend: string
  },
  liste_enfants: Array<CardType>,
  liste_cards: Array<CardType>,
  articles: Array<ArticleType>,
  news: Array<NewsNunType>,
  status: Status,
  match: {
    params: {
      slug: string
    }
  },
  pageSlug: string
};

class PageHubEntreprise extends Component<Props> {

  _renderContent = () => {
    const { liste_enfants } = this.props;

    const firstContainer = liste_enfants && liste_enfants[0] && liste_enfants[0].liste_enfants;
    const secondContainer = liste_enfants && liste_enfants[1] && liste_enfants[1].liste_enfants;

    return (
      <Fragment>
        <div className='row mb-5 mb-md-6 mb-lg-8'>
          {firstContainer && this._renderEntrepriseCards(firstContainer)}
        </div>
        <h2 className='mb-3'>{this._getTextByType('title', 1)}</h2>
        <div className='row mb-5 mb-md-6 mb-lg-8'>
          {secondContainer && this._renderPartenaireCards(secondContainer)}
        </div>
      </Fragment>
    );
  }

  _renderEntrepriseCards = (cards: Array<CardType>): Array<any> => {
    const { slug } = this.props.match.params;

    return cards.map((card, index) => {
      let classNameContainer = 'col col-md-6 col-lg-8 mb-2 mb-md-0';

      if (index === 1) {
        classNameContainer = 'col col-md-6 col-lg-4 mb-2 mb-md-0';
      }

      return (
        <div key={index} className={classNameContainer}>
          <CardBackground
            url={`/${slug}/${card.object_slug}`}
            backgroundUrl={card.featured_media}
            title={card.title}
            desc={card.description}
            linkLabel={card.texte_cta}
          />
        </div>
      );
    });
  };

  _renderPartenaireCards = (cards: Array<CardType>): Array<any> => {
    const { slug } = this.props.match.params;

    return cards.map((card, index) => {
      let classNameContainer = 'col col-md-6 col-lg-8 mb-2 mb-md-0';

      if (index === 1) {
        classNameContainer = 'col col-md-6 col-lg-4 mb-2 mb-md-0';
      }

      return (
        <div key={index} className={classNameContainer}>
          <CardThumbnail
            url={`/${slug}/${card.object_slug}`}
            backgroundUrl={card.featured_media}
            title={card.title}
            desc={card.description}
            linkLabel={card.texte_cta}
          />
        </div>
      );
    });
  };

  _getTextByType = (type: 'title'|'description', index: number): string => {
    const { liste_enfants } = this.props;

    if (liste_enfants && liste_enfants[index] && liste_enfants[index][type]) {
      return liste_enfants[index][type];
    }

    return (typeof this.props[type] === 'string' && this.props[type]) || '';
  }

  render() {
    const {
      featured_media,
      title,
      articles,
      news,
      label,
    } = this.props;

    return (
      <Fragment>
        <section className="banner banner--bigNoAfter">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{this._getTextByType('title', 0)}</h1>
            <p className="banner__desc">{this._getTextByType('description', 0)}</p>
          </div>
        </section>
        <div className="container container--ride-up">
          {this._renderContent()}
          { news.length > 0 &&
          <FooterNews news={news} slug={''} label={title} /> }
          { news.length === 0 && articles.length > 0 &&
          <FooterArticle articles={articles} slug={label.slug} label={label.name} /> }
        </div>
      </Fragment>
    );
  }
}

export default PageHubEntreprise;
